<template>
  <van-popup v-model="show" round position="center">
  <div class="container">
     <div class="h1">{{ title }}</div>
     <div class="content">{{ content}}</div>
     <div class="btn" @click="handleBtn">{{ btnTitle }}</div>
  </div>
</van-popup>
</template>
<script>
export default {
name:'tipPop',
props:{
  title: {
    type: String,
    default: '温馨提示'
  },
  content: {
    type: String,
    default: '请上传文本内容的pptx/pdf/docx/txt/md/csv文件'
  },
  btnTitle: {
    type: String,
    default: '知道了'
  }
},
components:{},
data() {
  return {
    show: false,
    callback:null,
  }
},
methods: {
       // 关闭
  close() {
    this.show = false;
  },
  open(callback=null) {
    this.show = true;
    this.callback = callback;
  },
  handleBtn() {
    // this.$emit("handleBtn")
    if(this.callback && typeof(this.callback) == 'function') {
      console.log("点击知道了执行")
      this.callback()
    }
  },
},
mounted() {}
}
</script>
<style scoped lang="less">
.container {
  width: 300px;
  height: 212px;
  padding: 19px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column wrap;
  
  .h1 {
    font-weight: 700;
    font-size: 16px;
    color: #262626;
    text-align: center;
  }
  .content {
  margin-top: 19px;;
  font-size: 15px;
  color: #595959;
  text-align: center;
  }
  .btn {
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    background: #00C4C9;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    margin-top: auto;
  }
}
</style>